<template>
    <div v-show="show" class="toast">
        <p v-for="(message, index) in messages" :key="index">{{ message }}</p>
    </div>
</template>

<script>
import { Bus, Stops } from '../../common/bus';

export default {
    data() {
        return {
            messages: [],
        };
    },
    computed: {
        show() {
            return this.messages.length > 0;
        },
    },
    created() {
        Bus.$on(Stops.TOAST, this.toast);
    },
    beforeDestroy() {
        Bus.$off(Stops.TOAST, this.toast);
    },
    methods: {
        toast(message) {
            this.messages.push(message);
            setTimeout(() => {
                this.messages.shift();
            }, 5000);
        },
    },
};
</script>

<style lang="scss" scoped>
@keyframes slide-in {
    from {
        right: -12rem;
    }
    to {
        right: 0;
    }
}
.toast {
    font-size: 1.2rem;
    padding: 1rem;
    position: absolute;
    border: lightgray;
    border-radius: 4px;
    opacity: 0.9;
    width: 10rem;
    right: 0;
    top: $headerHeight * 1.7;
    background-color: rgb(220, 220, 220);
    // animation-name: slide-in;
    // animation-duration: 1.5s;
}
</style>
